// frontend/src/utils/navigation.js
import { isIOS } from './deviceDetection';

export const getNavigationUrl = (address, lat, lon) => {
  const isIOSDevice = isIOS();

  if (isIOSDevice) {
    // Apple Maps (iOS)
    if (lat && lon) {
      return `maps://maps.apple.com/?daddr=${lat},${lon}&dirflg=d`;
    } else {
      const encodedAddress = encodeURIComponent(address);
      return `maps://maps.apple.com/?daddr=${encodedAddress}&dirflg=d`;
    }
  } else {
    // Google Maps (Android/Desktop)
    if (lat && lon) {
      return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`;
    } else {
      const encodedAddress = encodeURIComponent(address);
      return `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
    }
  }
};

export const openNavigation = (address, lat, lon) => {
  const url = getNavigationUrl(address, lat, lon);
  window.open(url, '_blank');
};

